import React, { Component } from 'react';
import { ReactSVG } from 'react-svg';

import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Modal from 'react-bootstrap/Modal';

import styles from './Email.module.css';

import headerImage from './../images/modules/email.jpg';

import addIcon from './../icons/ic_add_circle.svg';

import { CPLBanner } from '../../../components/Banner';
import { LanguageContext } from '../../../i18n/LanguageContext';

import { EmailService } from '../../../services/ApiService';

export default class EmailModule extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            search: '',
            showEditor: false,
            emailLists: [],
            emailList: null
        }
    }

    onSearch = (search) => {
        this.setState({ search });
    }

    onSave = (id, emails) => {
        EmailService.set({ id, emails })
            .then(() => {
                this.setState({ showEditor: false, emailList: null, successModalShow: true });
                this.getData();
            })
            .catch(e => console.error(e));
    }

    onCloseEditor = () => {
        this.setState({ showEditor: false, emailList: null });
    }

    getData = () => {
        EmailService.get()
            .then(emailLists => {
                this.setState({ emailLists });
            })
            .catch(e => console.error(e));
    }

    componentDidMount() {
        this.getData();
    }

    onRowClicked = (data) => {
        this.setState({ showEditor: false });
        setTimeout(() => {
            this.setState({ showEditor: true, emailList: data });
        }, 0);
    }

    filterContents(search, emailList, properties) {
        for (let prop of properties) {
            if (RegExp(`(.)*${search}(.)*`, 'i').test(emailList[prop])) {
                return true;
            }
        }
        return false;
    }

    render() {
        let emailLists = this.state.emailLists.map(emailList => {
            emailList.name = this.context[`EVT_${emailList.type}`];
            return emailList;
        });

        if (!!this.state.search) {
            emailLists = emailLists
                .filter(emailList => this.filterContents(this.state.search, emailList, [
                    'name'
                ]));
        }

        return <div className="col-md-12">
            <div className="row banner-wrapper">
                <div className="col-md-12">
                    <CPLBanner
                        img={headerImage}
                        content={this.context['EMAIL_ADMIN_MODULE_NAME']} />
                </div>
            </div>
            <div className="row">
                <div className="col-lg-7 col-md-7">
                    <EmailAdmin
                        emailLists={emailLists}
                        onRowClicked={this.onRowClicked}
                        onSearch={this.onSearch} />
                </div>
                <div className="col-lg-5 col-md-5">
                    {!!this.state.showEditor ? <Editor
                        onSave={this.onSave}
                        onClose={this.onCloseEditor}
                        emailList={this.state.emailList || {}}
                    /> : null}
                </div>
            </div>

            <SuccessSaveModal
                show={this.state.successModalShow}
                onHide={() => { this.setState({ successModalShow: false }) }} />
        </div>
    }
}

class EmailAdmin extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            search: ''
        };
    }

    onSearchListener = (evt) => {
        this.props.onSearch(evt.target.value);
        this.setState({ search: evt.target.value });
    }

    render() {
        return <div>
            <div className="card">
                <div className="card-header">
                    {this.context['COMMERCES']}
                    <span className="float-right">
                        <div className={styles['search-form']}>
                            <input type="text" value={this.state.search} onChange={this.onSearchListener} placeholder={`${this.context['SEARCH']}...`} />
                        </div>
                    </span>
                </div>
                <div className="card-body">
                    <table className="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th>{this.context['EMAIL_LIST_TYPE_TITLE']}</th>
                                <th>{this.context['EMAIL_LIST_COUNT_TITLE']}</th>
                            </tr>
                        </thead>
                        <ListItems
                            lang={this.context}
                            onRowClicked={this.props.onRowClicked}
                            emailLists={this.props.emailLists} />
                    </table>
                </div>
            </div>
        </div>
    }
}

const ListItems = (props) => {
    return <tbody>
        {props.emailLists.map((emailList, index) => {
            return <ListItem
                key={index}
                index={index}
                onRowClicked={props.onRowClicked}
                emailList={emailList}
                lang={props.lang} />
        })}
    </tbody>
}

const ListItem = (props) => {
    const emailList = props.emailList;

    return <tr className={styles['editor-row-clickable']} onClick={() => props.onRowClicked(emailList)}>
        <td>{emailList.name}</td>
        <td>{emailList.emails.length}</td>
    </tr>
}

class Editor extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);

        this.state = {
            emailList: this.props.emailList,
            isValidSave: true,
            selectedEmails: this.props.emailList.emails.map(() => false)
        };
    }

    onSave = () => {
        if (this.validateEmails()) {
            const id = this.state.emailList.id;
            let uniqueEmails = new Set(this.state.emailList.emails.filter(email => {
                return /\S+@\S+\.\S+/.test(email);
            }));

            const emails = [...uniqueEmails];
            this.props.onSave(id, emails)
        }
    }

    onDeleteEmail = (index) => {
        const emailList = this.state.emailList;

        emailList.emails = emailList.emails.filter((_, i) => {
            if (i !== index) {
                return true;
            }

            return false;
        });

        this.setState(emailList);
    }

    onSelectEmail = (index) => {
        const selectedEmails = this.state.selectedEmails;
        selectedEmails[index] = !selectedEmails[index];
        this.setState({ selectedEmails });
    }

    onChangeEmail = (email, index) => {
        const emailList = this.state.emailList;
        emailList.emails[index] = email;

        this.setState(emailList);
        // this.validateEmails();
    }

    onAddEmail = () => {
        const emailList = this.state.emailList;
        emailList.emails.push('');

        this.setState(emailList);
        // this.validateEmails();
    }

    validateEmails = () => {
        let isValidSave = true;
        this.state.emailList.emails.filter(email => {
            isValidSave = isValidSave * /\S+@\S+\.\S+/.test(email);
            return isValidSave;
        });

        this.setState({ isValidSave });

        return isValidSave;
    }

    deleteSelectedEmails = () => {
        const selectedEmails = [];
        const emails = [];
        const emailList = this.state.emailList;
        const existingEmails = emailList.emails;

        this.state.selectedEmails.forEach((shouldDelete, i) => {
            if (!shouldDelete) {
                emails.push(existingEmails[i])
                selectedEmails.push(false);
            }
        });

        emailList.emails = emails;

        this.setState({ selectedEmails, emailList });
    }

    render() {
        const emailList = this.state.emailList;

        const dotStyle = {
            color: '#f00'
        }

        const labelClassName = `col-md-4`;
        const labelValueClassName = `col-md-8`;

        let isSelectedEmail = false;
        this.state.selectedEmails.forEach(isSelected => {
            if (isSelected) {
                isSelectedEmail = true;
            }
        });

        return <div className="card">
            <div className="card-header">
                {this.context[`EVT_${emailList.type}`]}
                <span className="float-right">
                    <div className={styles['item-icon']}>
                        <OverlayTrigger
                            key="top"
                            placement="top"
                            overlay={<Tooltip>{this.context['ADD']}</Tooltip>}>
                            <div className={styles['panel-button']}>
                                <ReactSVG
                                    src={addIcon}
                                    className={styles['add-button']}
                                    onClick={this.onAddEmail} />
                            </div>
                        </OverlayTrigger>
                    </div>
                </span>
            </div>
            <div className={`card-body ${styles['editor-rows']}`}>
                {!this.state.isValidSave ? <div className={`row ${styles['editor-rows']}`}>
                    <div className={`col-md-12 ${styles['editor-error-container']}`}>
                        <div className={styles['editor-error-message']}>
                            <b>{this.context['EMAIL_INPUTS_INVALID']}</b>
                        </div>
                    </div>
                </div> : null}
                <div className={`row ${styles['editor-rows']}`}>
                    <div className={labelClassName}>
                        <p className={styles['editor-form-control-label']}>{this.context['EMAIL_LIST_COUNT_TITLE']} <b style={dotStyle}>*</b></p>
                    </div>
                    <div className={labelValueClassName}>

                    </div>
                </div>
                <EmailListItems
                    context={this.context}
                    onSelectEmail={this.onSelectEmail}
                    onDeleteEmail={this.onDeleteEmail}
                    onChangeEmail={this.onChangeEmail}
                    selectedEmails={this.state.selectedEmails}
                    emails={emailList.emails} />
            </div>
            <div className="card-footer">
                <span className="float-right">
                    <Button variant="success" onClick={this.onSave}>
                        {this.context['SAVE']}
                    </Button>
                </span>
                {!!isSelectedEmail ? <span className="float-right">
                    <Button variant="warning" onClick={() => this.deleteSelectedEmails()}>
                        {this.context['DELETE']}
                    </Button>
                </span> : null}
                <span className="float-right">
                    <Button variant="danger" onClick={() => this.props.onClose()}>
                        {this.context['CLOSE']}
                    </Button>
                </span>
            </div>
        </div>
    }
}

const EmailListItems = (props) => {
    return <div>
        {props.emails.map((email, i) => {
            const isSelected = props.selectedEmails[i];
            return <EmailItem
                onSelectEmail={props.onSelectEmail}
                onChangeEmail={props.onChangeEmail}
                onDeleteEmail={props.onDeleteEmail}
                email={email}
                context={props.context}
                key={i}
                isSelected={isSelected}
                index={i} />
        })}
    </div>
}

const EmailItem = (props) => {
    const email = props.email;
    const index = props.index;
    const isSelected = props.isSelected || false;

    let formClass = 'editor-form-control';
    if (!/\S+@\S+\.\S+/.test(email)) {
        formClass = 'editor-form-control-error';
    }

    return <div className={`row  ${styles['input-email-row']}`}>
        <div className="col-md-4 text-right">
            <input type="checkbox" checked={isSelected} onChange={() => props.onSelectEmail(index)} />
        </div>
        <div className="col-md-8">
            <input className={styles[formClass]} value={email} onChange={(evt) => props.onChangeEmail(evt.target.value, index)} />
        </div>
    </div>
}

class SuccessSaveModal extends Component {

    static contextType = LanguageContext;

    constructor(props, context) {
        super(props, context);
        this.state = {
            show: props.show
        }
    }

    onHide = () => {
        this.props.onHide();
    }

    render() {
        return <Modal show={this.props.show} onHide={this.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{this.context['EMAIL_LIST_SAVED_SUCCESSFULLY_TITLE']}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{this.context['EMAIL_LIST_SAVED_SUCCESSFULLY_BODY']}</Modal.Body>
        </Modal>
    }
}